import React ,{ useState } from 'react';
import styles from '../Styles/MasterPage/MasterPageLayout.module.css' 
import { useSelector } from 'react-redux';
import Enum from '../Common/Enum/Enum.jsx';
import Headers from  '../Components/Header/Header.jsx'
import Footer from '../Components/Footer/Footer.jsx';
import Pedido from '../Pages/Pedido/Pedido.jsx';


const MasterLayout  = ({ children ,layoutHeader, menu}) => {

  /*const centauri = useSelector((state) => state.auth.centauri); */ 
  const [selectedItem, setSelectedItem] = useState(null); 
  const orderItems = useSelector((state) => state.orderStorage.orderItems);

  return (
    <div className={styles.layout}>       
      <Headers className={styles.tophead} selectedItem={selectedItem}  setSelectedItem={setSelectedItem} totalOrder={orderItems.length}></Headers>     
      <div className={styles.mainLayoutContainer}>     
        <div className={styles.menuLayout}>
          {(selectedItem=== Enum.MENU || selectedItem === null) && menu}
          { selectedItem=== Enum.PEDIDO && <Pedido/>}
        </div>
      </div>
      <Footer>
          <p>&copy; 2025  BEETECH All rights reserved.</p>
      </Footer>
    </div>
  );
};

export default MasterLayout ;